module.exports = __webpack_public_path__ + "static/img/huizhang.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huizhang.png
// module id = Yla9
// module chunks = 9